import { createSchema } from '@/shared/validations';
import {
  postalCode,
  street,
  number,
  neighborhood,
} from '@/shared/validations/schemas';

const setAddressOnEditStep = createSchema({
  postalCode,
  street,
  number,
  neighborhood,
});

export { setAddressOnEditStep };
